import { createFileRoute, notFound } from "@tanstack/react-router";
import { ServicePage } from "@/components/site/service-page";
import { localBusinessJsonLd, serviceJsonLd } from "@/components/site/jsonld";
import { hentLiveTjenester } from "@/lib/tjenester";
import { extraLiveServicePages, SITE } from "@/lib/site";

/**
 * Side for tjenester eieren har lagt til i Ascendly som ikke har en egen
 * fil under src/routes. De faste tjenestene (premiumpakke-drammen osv.) har
 * hver sin fil med haandskrevet SEO-tekst; alt eieren legger til senere
 * lander her, med tekst fra appen. Uten denne fantes en ny tjeneste bare i
 * prislista og bookingen, og aldri i menyen «Tjenester».
 */
export const Route = createFileRoute("/tjenester/$slug")({
  loader: async ({ params }) => {
    const live = await hentLiveTjenester();
    const page = extraLiveServicePages(live).find((p) => p.slug === params.slug);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: loaderData.title },
          { name: "description", content: loaderData.desc },
          { property: "og:title", content: loaderData.title },
          { property: "og:description", content: loaderData.desc },
          { property: "og:type", content: "website" },
          { property: "og:url", content: `${SITE.url}/tjenester/${loaderData.slug}` },
        ]
      : [],
    links: loaderData ? [{ rel: "canonical", href: `${SITE.url}/tjenester/${loaderData.slug}` }] : [],
    scripts: loaderData
      ? [
          { type: "application/ld+json", children: JSON.stringify(localBusinessJsonLd()) },
          { type: "application/ld+json", children: JSON.stringify(serviceJsonLd(loaderData.h1, loaderData.desc)) },
        ]
      : [],
  }),
  component: LiveServiceRoute,
});

function LiveServiceRoute() {
  const page = Route.useLoaderData();
  return <ServicePage slug={page.slug} fallback={page} />;
}
